import React from "react";
import { library }  from '@fortawesome/fontawesome-svg-core'
import { faDiscord, faFacebook, faTwitter, faGithub } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope, faMapMarker } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';

library.add(faDiscord, faEnvelope, faMapMarker, faFacebook, faTwitter, faGithub);

const AppFooter = () => {
    return (
        <footer className="container">
            <div className="row space-2">
                <div className="col-md-4 mb-7 mb-md-0">
                    <div className="media">
                        <span className="btn btn-icon btn-soft-primary rounded-circle mr-3">
                            <FontAwesomeIcon icon={faDiscord} className="mb-0 btn-icon__inner" />
                        </span>
                        <div className="media-body">
                            <h4 className="h6 text-white font-weight-normal mb-0"> <Link to="/policy"> Privacy Policy </Link></h4>
                            {/* <span className="d-block font-size-1 text-white"><a href="">Our Facebook</a></span> */}
                        </div>
                    </div>
                </div>

                <div className="col-md-4 mb-7 mb-md-0">
                    <div className="media">
                        <span className="btn btn-icon btn-soft-primary rounded-circle mr-3">
                            <FontAwesomeIcon icon={faEnvelope} className="mb-0 btn-icon__inner" />
                        </span>
                        <div className="media-body">
                            <h4 className="h6 text-white font-weight-normal mb-0">Email us</h4>
                            <span className="d-block font-size-1 text-white">info@thezimble.com</span>
                            <span className="d-block font-size-1 text-white"><a href="https://forms.gle/ppSotcR73RmQPHEX7" rel="noopener noreferrer" target="_blank">Contact Us</a></span>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="media">
                    <span className="btn btn-icon btn-soft-primary rounded-circle mr-3">
                        <FontAwesomeIcon icon={faMapMarker} className="mb-0 btn-icon__inner" />
                    </span>
                    <div className="media-body">
                        <h4 className="h6 text-white font-weight-normal mb-0"><Link to ="/terms"> Terms and Conditions</Link></h4>
                        {/* <span className="d-block font-size-1 text-white">Seattle</span> */}
                    </div>
                    </div>
                </div>
            </div>

            
        </footer>
    );
}

export default AppFooter;